<template>
    <div class="col-md-12 mb-4 profile-media-gallery" v-if="hasPremiumContent || hasFreeVideos">

        <EscortProfileMobileGalleryBlockComponent class="d-none d-md-flex"
                                                  :user="user"
                                                  @gallerySubscribeClick="$emit('gallerySubscribeClick', $event)"
                                                  @freeVideoClick="$emit('freeVideoClick')"/>

        <div class="profile-subscribe-to-gallery-block" v-if="hasPremiumContent">
            <div class="gallery-block-heading">
                <GemFilledComponent width="28px" height="28px"/>

                <h5 class="mb-0">{{ translate.product.premiumAndCustomContent }}</h5>
                <p class="mb-0">{{ isVideoUploadEnabled ? translate.home.unlockPremiumContentDescription : translate.home.unlockPremiumContentDescriptionPhotosOnly }}</p>
            </div>

            <div class="gallery-block-text">
                <div class="gallery-block-text--quantity">
                    <div>
                        <span class="mr-2">{{ aggregatedTotals.photoQuantity }}</span>
                        {{ aggregatedTotals.photoQuantity > 1 ? translate.product.galleryPremiumPhotos[1] : translate.product.galleryPremiumPhotos[0] }}
                    </div>

                    <div v-if="isVideoUploadEnabled">
                        <span class="mr-2">{{ aggregatedTotals.videoQuantity }}</span>
                        {{ aggregatedTotals.videoQuantity > 1 ? translate.product.galleryPremiumVideos[1] : translate.product.galleryPremiumVideos[0] }}
                    </div>
                </div>

                <button class="btn btn-rebrand-primary btn-rebrand-sm gallery-block-button w-full"
                        @click.prevent="onGalleryClick">
                    {{ translate.home.unlockPremiumNow }}
                </button>

                <button v-if="isRequestContentButtonVisible"
                        class="btn btn-rebrand-primary btn-rebrand-sm gallery-block-button w-full"
                        @click.prevent="$emit('requestCustomContentClick')">
                    {{ translate.account.requestCustomContent }}
                </button>
            </div>

            <GemOutlineComponent class="bg-1" width="372px" height="292px" />
            <GemOutlineComponent class="bg-2" width="372px" height="292px" />
        </div>
    </div>
</template>

<script>

import userMixin from "@/components/mixins/userMixin";
import GemFilledComponent from "@/components/global/icons/GemFilledComponent.vue";
import GemOutlineComponent from "@/components/global/icons/GemOutlineComponent.vue";
import EscortProfileMobileGalleryBlockComponent
    from "@/components/users/partials/EscortProfileMobileGalleryBlockComponent.vue";

export default {
    components: {EscortProfileMobileGalleryBlockComponent, GemOutlineComponent, GemFilledComponent},
    computed: {
        ...mapState(['currentUser', 'translate', 'regionData']),
        isVideoUploadEnabled() {
            return !_.has(this.regionData, 'sectionsToHide.videoUpload');
        },
        allGalleries() {
            return _.get(this, 'user.galleries', []).filter(g => g.defaultPhoto || g.videoThumbnail);
        },
        hasMultipleGalleries() {
            return this.allGalleries.length > 1;
        },
        aggregatedTotals() {
            return this.allGalleries.reduce((acc, g) => ({
                photoQuantity: acc.photoQuantity + (g.photoQuantity || 0),
                videoQuantity: acc.videoQuantity + (g.videoQuantity || 0),
            }), { photoQuantity: 0, videoQuantity: 0 });
        },
        gallery() {
            return this.allGalleries[0] || null;
        },
        hasPremiumContent() {
            return this.gallery && (this.aggregatedTotals.photoQuantity || this.aggregatedTotals.videoQuantity);
        },
        hasFreeVideos() {
            return _.get(this, 'user.videos', []).some(v => v.is_uploaded);
        },
    },
    props: {
        user: {
            type: Object,
            default: null
        }
    },
    methods: {
        onGalleryClick() {
            this.$emit('gallerySubscribeClick', this.hasMultipleGalleries ? null : this.gallery);
        }
    },
    mixins: [
        userMixin,
    ],
}
</script>
